<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Sổ sách Chủ nhiệm"
          :link="[
            {
              text: 'Cấp học',
              href: '/teachingDoc'
            },
            {
              text: 'Sổ sách chủ nhiệm'
            }
          ]"
        />
      </div>
    </div>
    <div id="app">
      <div v-if="isLoading" class="center-screen">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <TreeNode v-else :node="homeClassTreeData"></TreeNode>
    </div>
  </div>
</template>

<script>
import TreeNode from '@/components/basic/tree/TreeNode.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { mapActions, mapState } from 'vuex'
import { TeacherCat } from '../../plugins/api'
export default {
  components: {
    TreeNode,
    Breadcrumbs
  },
  computed: {
    ...mapState('auth', ['profile'])
  },
  data() {
    return {
      homeClassTreeData: {
        name: `Sổ sách chủ nhiệm cấp ${this.$route.params.level === 'secondary' ? 2 : 3}`,
        children: []
      },
      isLoading: true
    }
  },
  mounted() {
    this.initializeHomeClassTree()
  },
  methods: {
    ...mapActions('teacherDoc', ['fetchTeachings', 'fetchClasses']),

    async initializeHomeClassTree() {
      this.isLoading = true
      const type = this.$route.params.level
      try {
        const organizedData = await TeacherCat.fetchTree(type, 'class')
        this.homeClassTreeData.children = organizedData
      } catch (error) {
        console.error('Failed to fetch teachings data:', error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
